// src/config/constants.js

// TODO: Atualize com o CNPJ real (apenas números) do Ecoparque Timbó.
export const CNPJ_ECOPARQUE = "08855628000180";
